import { COMMON } from '@constants';
import { FlowPageFragment } from '@graphql/generated/graphql';
import { TFunction } from 'next-i18next';

import { Alignment as TAlignment, Escape as TEscape } from '../types';
import {
    isDividerFlowPage,
    isFlowPageSkippable,
    isRegistrationRequired,
    isSellFlowPage,
    isWelcomeFlowPage,
} from './validators';
import { Alignment as EAlignment, Escape as EEscape } from '../enums';

export const getHeadingAlignment = (flowPage: FlowPageFragment): TAlignment => {
    return isWelcomeFlowPage(flowPage) || isSellFlowPage(flowPage)
        ? EAlignment.Start
        : EAlignment.Center;
};

export const getDescriptionAlignment = (
    flowPage: FlowPageFragment
): TAlignment => {
    if (
        isWelcomeFlowPage(flowPage) ||
        (isDividerFlowPage(flowPage) && !flowPage.Registration) ||
        isSellFlowPage(flowPage)
    ) {
        return EAlignment.Start;
    }

    return EAlignment.Center;
};

export const getCtaText = (
    t: TFunction,
    flowStep: number,
    flowPage: FlowPageFragment
): string => {
    if (flowPage.CtaText) {
        return flowPage.CtaText;
    }

    if (flowStep === 1) {
        return t('start');
    }

    return t(`${COMMON}:continue`);
};

export const getEscapeText = (t: TFunction, flowStep: number): string => {
    if (flowStep === 1) {
        return t('skip');
    }

    return t('save_product_later');
};

export const getEscapeType = ({
    flowCurrentStep,
    flowTotalSteps,
    flowPage,
    flowPageIsProcessing = false,
}: {
    flowCurrentStep: number;
    flowTotalSteps: number;
    flowPage: FlowPageFragment;
    flowPageIsProcessing?: boolean;
}): TEscape | undefined => {
    if (flowPageIsProcessing) return;

    const _isRegistrationRequired = isRegistrationRequired(flowPage);

    if (
        isFlowPageSkippable({
            isRegistrationRequired: _isRegistrationRequired,
            flowCurrentStep,
            flowTotalSteps,
            flowPage,
        })
    ) {
        return EEscape.Skip;
    }

    if (isSellFlowPage(flowPage)) {
        return EEscape.Exit;
    }

    if (!_isRegistrationRequired && flowPage.AllowExit) {
        return EEscape.Exit;
    }
};
